const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatApiError = (detail, fallback = "Something went wrong. Please try again.") => {
    if (detail == null) return fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => {
                if (e && typeof e.msg === "string") return e.msg.replace(/^Value error, /, "");
                return JSON.stringify(e);
            })
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
};

export const apiFetch = async (path, options = {}) => {
    const res = await fetch(`${API}${path}`, {
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        ...options,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(formatApiError(data.detail));
    return data;
};

export default apiFetch;
